import React from 'react'
import { connect } from 'react-redux'
import Validator from 'validatorjs'

import BasePureComponent from 'utils/BasePureComponent'
import Input from 'components/Input'

import NewDriver from './NewDriver'

import {
  addDriver
} from 'components/DriversForm/actions'

import './style.scss'


export class DriverRow extends BasePureComponent {
  constructor(props) {
    super(props)

    this.VALIDATION_RULES = {
      first_name: 'string|required',
      last_name: 'string|required',
      email: 'email|required'
    }

    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      buttonProps: {
        disabled: true
      },
      validationRules: {},
      errors: {}
    }

    this._bind('_renderDriver', '_onAdd', '_onChange', '_validate')
  }

  _renderDriver(uuid) {
    const driver = this.props.drivers[uuid]

    return (
      <NewDriver
        key={uuid}
        uuid={uuid}
        driver={driver}
        onInputChange={this._onDriverChange}
        onDelete={() => this._onDelete(driver.id)}
      />
    )
  }

  _onAdd(evt) {
    evt.preventDefault()

    if (!this.state.first_name || !this.state.last_name || !this.state.email)
      return

    this.props.addDriver(this.state.first_name, this.state.last_name, this.state.email)
    this.setState({
      first_name: '',
      last_name: '',
      email: '',
      errors: {},
      validationRules: {},
      buttonProps: {
        disabled: true
      }
    })
  }

  _validate() {
    const validator = new Validator({
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email
    }, this.state.validationRules)

    const isFullValidation = Object.keys(this.state.validationRules).length === Object.keys(this.VALIDATION_RULES).length

    if (validator.passes()) {
      // validation might pass but not all this.VALIDATION_RULES have been checked!
      this.setState({ buttonProps: {
        disabled: !isFullValidation  // enabled only if all validation rules have been checked!
      }, errors: {} })
    } else {
      this.setState({
        errors: { ...validator.errors.errors },
        buttonProps: { disabled: true }
      })
    }
  }

  async _onChange(evt) {
    const validationRules = {...this.state.validationRules}
    const name = evt.target.name
    const value = evt.target.value

    if ( !!value ) {
      validationRules[name] = this.VALIDATION_RULES[name]
    } else if ( !!validationRules[name] ) {
      delete validationRules[name]
    }

    await this.setState({
      [evt.target.name]: evt.target.value,
      validationRules
    })

    this._validate()
  }

  render() {
    return (
      <div>
        {this.props.drivers_order.map(this._renderDriver)}
        <div className="DriversForm__DriverRow-row">
          <Input
            errors={this.state.errors.first_name}
            label="Nombre(s)"
            name="first_name"
            placeholder="Nombre(s)"
            onChange={this._onChange}
            value={this.state.first_name} />
          <Input
            errors={this.state.errors.last_name}
            label="Apellidos"
            name="last_name"
            placeholder="Apellidos"
            onChange={this._onChange}
            value={this.state.last_name} />
          <Input
            errors={this.state.errors.email}
            label="Correo electrónico"
            name="email"
            placeholder="Correo electrónico"
            onChange={this._onChange}
            value={this.state.email} />
          <div className="button-wrapper">
            <button onClick={this._onAdd} className="add" {...this.state.buttonProps}>
              <i className="material-icons">add</i> Agregar
            </button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    drivers: state.driversForm.get('drivers').toJS(),
    drivers_order: state.driversForm.get('drivers_order').toJS()
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addDriver: (firstName, lastName, email) => dispatch(addDriver(firstName, lastName, email)),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(DriverRow)



// WEBPACK FOOTER //
// ./src/components/DriversForm/DriversList/index.js